import { ContentContext } from "../../../../../utils/contexts";

import {  Breadcrumbs as MUIBreadcrumbs, Button, IconButton  } from "@mui/material";
import {  ChevronLeft  } from "@mui/icons-material";
import {  NavigateNext  } from "@mui/icons-material";
import Dropdown from './Dropdown';

class Breadcrumbs extends React.PureComponent {
  render() {
    const { breadcrumbs, onBreadcrumbClick, loadingContent } = this.context;

    const isSiteRoot = breadcrumbs.length <= 1;

    return (
      <div className="Breadcrumbs">
        <IconButton onClick={() => onBreadcrumbClick(breadcrumbs[breadcrumbs.length - 2])} disabled={isSiteRoot || loadingContent} id="backBtn">
          <ChevronLeft fontSize="small" />
        </IconButton>
        <MUIBreadcrumbs sx={{margin: '0'}} separator={<NavigateNext fontSize="small" />}>
          {breadcrumbs.length <= 5
            ? breadcrumbs.map((item, index) => (
                <Button
                  sx={{textTransform: 'none',
										padding: '5px 5px !important',
										margin: '0 !important',
										minWidth: 'auto !important'}}
                  key={index}
                  onClick={() => onBreadcrumbClick(item)}
                  id={`breadcrumbs${index}`}
                  disabled={loadingContent}
                >
                  {item.name}
                </Button>
              ))
            : [
                <Button
									sx={{textTransform: 'none',
										padding: '5px 5px !important',
										margin: '0 !important',
										minWidth: 'auto !important'}}
                  onClick={() => onBreadcrumbClick(breadcrumbs[0])}
                  key={breadcrumbs[0].nodeRef}
                  id={`breadcrumbs${0}`}
                  disabled={loadingContent}
                >
                  {breadcrumbs[0].name}
                </Button>,
                <Dropdown
                  folders={breadcrumbs.slice(1, breadcrumbs.length - 1)}
                  onClick={onBreadcrumbClick}
                  key={breadcrumbs.length - 2}
                />,
                <Button
									sx={{textTransform: 'none',
										padding: '5px 5px !important',
										margin: '0 !important',
										minWidth: 'auto !important'}}
                  onClick={() => onBreadcrumbClick(breadcrumbs[breadcrumbs.length - 1])}
                  key={breadcrumbs.length - 1}
                  id={`breadcrumbs${breadcrumbs.length - 1}`}
                  disabled={loadingContent}
                >
                  {breadcrumbs[breadcrumbs.length - 1].name}
                </Button>,
              ]}
        </MUIBreadcrumbs>
      </div>
    );
  }
}

Breadcrumbs.contextType = ContentContext;

export default Breadcrumbs;
